export default __webpack_public_path__ + "static/media/bihada-factory-mission-07.1006a63a.jpg";